var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Change WP Admin Password ")]
          ),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "px-2",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _vm.installation
                        ? _c(
                            "p",
                            {
                              staticClass: "mb-0"
                            },
                            [
                              _vm._v(
                                " Change your WordPress admin password for " +
                                  _vm._s(_vm.installation.softdomain) +
                                  ". "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pb-0 px-2",
                      attrs: {
                        cols: "12",
                        md: "5"
                      }
                    },
                    [
                      _c(
                        "gg-input-label",
                        [
                          _vm._v(" Admin Username "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                bottom: ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function fn(_ref) {
                                    var on = _ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            staticClass: "mb-1",
                                            attrs: {
                                              color: "primary",
                                              small: ""
                                            }
                                          },
                                          on
                                        ),
                                        [_vm._v(" mdi-help-circle ")]
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "This is your current WP-Admin administrator username."
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c("gg-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          name: "Admin Username",
                          "error-messages": _vm.errors.collect("Admin Username")
                        },
                        model: {
                          value: _vm.admin_username,
                          callback: function callback($$v) {
                            _vm.admin_username = $$v
                          },
                          expression: "admin_username"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pb-0 px-2",
                      attrs: {
                        cols: "12",
                        md: "7"
                      }
                    },
                    [
                      _c("compact-password", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:8",
                            expression: "'required|min:8'"
                          }
                        ],
                        attrs: {
                          outlined: "",
                          charset:
                            "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMOPRSTUVWXYZ0123456789_",
                          autocomplete: "new-password",
                          label: "New Password",
                          "data-vv-name": "password",
                          "data-vv-as": "Password",
                          "error-messages": _vm.errors.collect("password"),
                          "with-generator": ""
                        },
                        model: {
                          value: _vm.admin_password,
                          callback: function callback($$v) {
                            _vm.admin_password = $$v
                          },
                          expression: "admin_password"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "px-5 pt-0 pb-3 justify-content-end"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.setAdminPassword
                  }
                },
                [_vm._v("Change Password")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }